<template>
    <div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-base">
        <vx-card class="md-4">
            <Tree :data="data5" enlarge-text="3" :render="renderContent"></Tree>

            <div id="Add-deptCarg">
                <vs-popup classContent="popup-example" :title="contentTitle" >
                    <vs-input class="inputx mb-3" :placeholder="contentPlaceHolder" v-model="value1" />
                    <vs-button @click="adiciona" color="primary" type="filled">Adicionar</vs-button>
                </vs-popup>
            </div>

            <div id="Altera-deptCarg">
                <vs-popup classContent="popup-example" :title="contentTitle" :active.sync="popupActive3">
                    <vs-input class="inputx mb-3" v-model="value2" />
                    <vs-button @click="altera" color="primary" type="filled">Alterar</vs-button>
                </vs-popup>
            </div>
        </vx-card>  
    </div>
</template>
<script>
    import TreeItem from "../queries/components/TreeItem";

    export default {
        data () {
            return {
                value1: '', /*eh um nome, e esta ligada a insercao de um novo departamento/cargo*/
                // popupActive2: false, /*ativa e inativa o popup de insercao*/ //(desativado)
                value2: '',/*eh um nome, e esta ligada a alteracao de um dept/cargo*/
                popupActive3: false,/*ativa e inativa o popup de alteracao*/
                total: 0,/*representa a quantidade de departamentos*/
                auxData: {}, /*esse auxData recebe o 'galho' atual que irah adicionar um filho quando clica no +*/
                contentTitle: '',/*conteudo do titulo para adicionar um novo cargo/departamento*/
                contentPlaceHolder: '',/*conteudo do titulo para adicionar um novo cargo/departamento*/
                data5: [
                    {
                        title: 'Departamentos e cargos',
                        expand: true,
                        render: (h, { root, node, data }) => {
                            return h('span', {
                                style: {
                                    display: 'inline-block',
                                    width: '100%'
                                }
                            }, [
                                h('span', [
                                    h('span', data.title)
                                ]),
                                h('span', {
                                    style: {
                                        display: 'inline-block',
                                        marginRight: '32px'
                                    }
                                }, [
                                    h('Button', {
                                        props: Object.assign({}, this.buttonProps, {
                                            icon: 'ios-add',
                                            type: 'primary'
                                        }),
                                        style: {
                                            width: '64px',
                                            marginLeft: '8px'
                                        },
                                        on: {
                                            click: () => {  this.show_input_add(data, 1)}
                                        }
                                    })
                                ])
                            ]);
                        },
                        children: [],
                    }
                ],
                buttonProps: {
                    type: 'default',
                    size: 'small',
                }
            }
        },
        methods: {
            renderContent (h, { root, node, data }) {
                switch (data.tipo) {
                    case 1: //aparece o cargo/departamento
                        return h('span', {
                            style: {
                                display: 'inline-block',
                                width: '100%'
                            }
                        },[
                            h('span',{
                                on:{
                                    click: () => {data.tipo = 3}
                                },
                            },[
                                h('span',{
                                    style:
                                    {
                                        cursor:'pointer',
                                    }
                                },data.title)
                            ]),
                            h('span', [
                                h('tooltip', {
                                    props: {
                                        trigger: 'hover',
                                        placement: 'right',
                                        theme: 'light',
                                    },
                                }, [
                                    h('icon', {
                                        props: {
                                            type: 'md-more',
                                            size: '15',
                                        },
                                    }),
                                    h('span', {
                                        class: ['api'],
                                        slot: ['content'],
                                    }, [
                                        //Botao para adicionar novos nos
                                        h('span', {
                                            style:{
                                                marginLeft:'2px'
                                            },
                                            on: {
                                                click: () => {
                                                    this.show_input_add(data, 2)
                                                }
                                            },
                                        }, [this.button1_active(data)]),//só exibe o botao se essa função retornar conteúdo

                                        //Botao para apagar nos
                                        h('span', {
                                            style:{
                                                marginLeft:'2px'
                                            },
                                            on: {
                                                click: () => {
                                                    if (this.permite_remocao(data)) {
                                                        this.remove(root, node, data)
                                                    }
                                                }
                                            },
                                        }, [this.button2_active(data)]),//só exibe o botao se essa função retornar conteúdo
                                    ]),
                                ]),
                            ])
                        ]);
                        break
                    case 2: //aparece o input para inserção
                        return h('span',[
                            h('i-input', {
                                props: {
                                    placeholder: 'Novo Nome',
                                    size: 'small',
                                },
                                style: {
                                    width:'120px'
                                },
                                on: {
                                    input: (val) => {this.value1 = val},
                                }
                            }),
                            h('Button', {
                                props: {
                                    icon: 'md-checkmark',
                                    size: 'small',
                                },
                                style: {
                                    marginLeft: '4px'
                                },
                                on: {
                                    click: () => {this.remove_input(root, node, data), this.adiciona()}
                                }
                            }),
                            h('Button', {
                                props: {
                                    icon: 'md-close',
                                    size: 'small',
                                },
                                style: {
                                    marginLeft: '4px'
                                },
                                on: {
                                    click: () => {this.remove_input(root, node, data)}
                                }
                            }),
                        ]);
                        break;
                    case 3: //aparece o input para alteração
                        return h('span', {
                            style: {
                                display: 'inline-block',
                                width: '100%',
                            }
                        },[
                            h('span',{
                                
                            },[
                                h('i-input',{ 
                                    props:{
                                        size:'small',
                                        placeholder:data.title,
                                    },
                                    style:{
                                        width:'120px',
                                    },
                                    on:{
                                        input: (val) => {this.value2 = val},
                                    }
                                }),
                                h('Button', {
                                props: {
                                    icon: 'md-checkmark',
                                    size:'small',
                                },
                                style: {
                                    marginLeft: '4px'
                                },
                                on: {
                                        click: () => {this.desativaInput(data), this.altera()}
                                    }
                                }),
                                h('Button', {
                                    props: {
                                        icon: 'md-close',
                                        size:'small',
                                    },
                                    style: {
                                        marginLeft: '4px'
                                    },
                                    on: {
                                        click: () => {this.desativaInput(data)}
                                    }
                                }),
                            ]),
                        ]);
                        break
                    default:
                        console.warn("Ocorreu algum erro no tipo de renderização!");
                }
            },

            desativaInput(data){
                this.auxData = data;
                data.tipo = 1
            },

            append (id) {
                const children = this.auxData.children || [];
                let aux;
                if (id == -1) { /*se o id == -1 significa que eh um departamento, e ele por si soh nao possui identificador*/
                    aux = {
                        title: this.value1,
                        pai: this.auxData.title,
                        tipo: 1, //aparece o cargo/departamento
                    };
                } else {
                    aux = {
                        title: this.value1,
                        pai: this.auxData.title,
                        id: id,
                        tipo: 1, //aparece o cargo/departamento
                    };
                }
                children.push(aux);
                this.$set(this.auxData, 'children', children);
                this.value1 = '';
            },

            async adiciona() {
                try {
                    if (this.auxData.title != 'Departamentos e cargos') {
                        let children = this.auxData.children || [];

                        const URI = 'cargo'
                        await this.$axios.post(URI, {
                            nome: this.value1,
                            departamento: this.auxData.title
                        }).then(({data}) => {
                            if (data.status) {
                                this.$Message.success({
                                    content: "Cargo inserido com sucesso!",
                                    duration: 5,
                                });
                                let aux = {
                                    title: this.value1,
                                    pai: this.auxData.title,
                                    id: data.id,
                                    tipo: 1,
                                };
                                children.unshift(aux);
                                this.$set(this.auxData, 'children', children);
                            }
                            else {
                                this.$Message.error({
                                    content: "Esse cargo ja existe no departamento!",
                                    duration: 5,
                                });
                            }
                        })
                            .catch((e) => {
                            console.warn(e);
                        })

                    } else {
                        /*se o pai eh intranet entao eh um departamento, e o cargo eh requisito para ele*/
                        let teste = this.data5[0].children.find( obj => obj.title === this.value1);
                        if (teste){
                            this.$Message.error({
                                content: 'O cargo informado já existe',
                                duration: 5,
                                themes: 'classic',
                                styles: {
                                    fontSize: 14
                                },
                            });
                        }
                        else {

                            let children = this.auxData.children || [];

                            let aux = {
                                title: this.value1,
                                pai: this.auxData.title,
                                tipo: 1,
                                children: [],
                            };

                            children.unshift(aux);
                            this.$set(this.auxData, 'children', children);

                            this.$Message.warning({
                                content: 'Um novo cargo precisa ser adicionado para o departamento!',
                                duration: 5,
                                themes: 'classic',
                                styles: {
                                    fontSize: 14
                                },
                            });

                        }
                    }
                    this.value1 = '';
                } catch (e) {
                    console.warn(e);
                }
            },

            permite_remocao (data){
                if(typeof data.children === "undefined"){
                    return true
                }else
                    if(data.children.length > 0){
                        this.$Message.warning(
                        {
                            content: 'Não é possível remover departamentos com cargos ativos',
                            duration: 5,
                            themes: 'classic',
                            styles: {
                                fontSize: 14 
                            },
                        });
                        return false;
                    }
                return true;
            },

            remove_input(root, node, data) {
                const parentKey = root.find(el => el === node).parent;
                const parent = root.find(el => el.nodeKey === parentKey).node;
                const index = parent.children.indexOf(data);
                parent.children.splice(index, 1);
            },

            async remove (root, node, data) {
                try {
                    if (data.pai != 'Departamentos e cargos') {
                        const URI = `cargo/${data.id}`;
                        await this.$axios.delete(URI)
                    } else {
                        this.total--;
                    }
                    const parentKey = root.find(el => el === node).parent;
                    const parent = root.find(el => el.nodeKey === parentKey).node;
                    const index = parent.children.indexOf(data);
                    parent.children.splice(index, 1);
                    this.$Message.success({
                                    content: "Cargo removido com sucesso!",
                                    duration: 5,
                                });
                } catch (e) {
                    console.warn(e)
                }
            },

            async altera(){
                if (this.auxData.pai == 'Departamentos e cargos') {//significa que auxdata eh um departamento
                    const URI = `cargo/departamento`
                    await this.$axios.put(URI,{novo_departamento: this.value2, velho_departamento: this.auxData.title})
                        .then(({data}) => {
                            if (data.status){
                                this.auxData.title = this.value2;
                                if (this.auxData.children) {
                                    this.auxData.children.map((cargo) => {
                                        return cargo.pai = this.value2;
                                    })
                                }
                                this.$Message.success({
                                    content: "Departamento alterado com sucesso!",
                                    duration: 5,
                                })
                            } else {
                                this.$Message.error({
                                    content: "O departamento informado já existe!",
                                    duration: 5,
                                })
                            }
                        })
                        .catch((e) => {
                            console.warn(e);
                        })
                } else { //eh um cargo
                    const URI = `cargo`
                    await this.$axios.put(URI, {nome: this.value2, departamento: this.auxData.pai, id_cargo: this.auxData.id})
                        .then(({data}) => {
                            if (data.status){
                                this.auxData.title = this.value2;
                                this.$Message.success({
                                    content: "Cargo alterado com sucesso!",
                                    duration: 5,
                                })
                            } else {
                                this.$Message.error({
                                    content: "O cargo informado já existe no departamento!",
                                    duration: 5,
                                })
                            }
                        })
                        .catch((e) => {
                            console.warn(e);
                        })
                }
                this.value2 = '';
                this.popupActive3 = false;
            },

            button1_active(data){
                if(data.pai === "Departamentos e cargos"){ //significa que e' um departamento
                    return [<Button icon="md-add" type="default" size="small"></Button>]
                }else{
                    return [];
                }
            },

            button2_active(data){
                if (typeof data.children === "undefined" || data.children < 1) {
                    return [<Button icon="md-trash" type="default" size="small"></Button>]
                }
            },

            show_input_add(data, tipo){
                data.children.unshift({tipo: 2});
                this.auxData = data;
            },

            show_input_altera(data, tipo){
                this.contentTitle = 'Alterar departamento';
                if (tipo == 2){
                    this.contentTitle = 'Alterar cargo';
                }
                this.value2 = data.title; //valor do cargo ou departamento
                this.auxData = data; //recebe toda a estrutura do objeto
                this.popupActive3 = true;
            },

            async getDept(){ /*The first param of load-data is current node data. Call the second param and transfer the data obtained.*/
                try {
                    const URI = 'cargo'
                    await this.$axios.get(URI)
                        .then(({data}) => {
                            let departamento = 1; /*o primeiro que vamos receber sempre sera um novo departamento pois nao ha ninguem ainda*/
                            let deptAtual = data[0].departamento; /*esse primeiro recebido jah eh um novo cargo e um novo departamento*/

                            for (let i = 0; i < data.length; i++) {

                                if (departamento){ /*adiciona um novo departamento*/
                                    deptAtual = data[i].departamento;
                                    this.auxData = this.data5[0]; /*recebo a raiz para adicionar novos filhos (departamentos)*/
                                    this.value1 = deptAtual;
                                    this.append(-1);
                                    this.total++;
                                }
                                /*adiciona um novo cargo para o último departamento adicionado*/
                                this.auxData = this.data5[0].children[this.total - 1];
                                this.value1 = data[i].nome;
                                this.append(data[i].id_cargo);

                                if ( i + 1 < data.length) {
                                    if (data[i + 1].departamento == deptAtual) {
                                        departamento = 0;
                                    } else {
                                        departamento = 1;
                                    }
                                }
                            }
                        })
                        .catch((e) => {
                            console.warn(e);
                        })
                    this.value1 = '';
                } catch (e) {
                    console.warn(e);
                }
            },
        },
        mounted() {
            this.getDept();
        }
    }
/*Problemas:
1- Falta expandir sozinho quando chamar a função de criar um filho

2- Não está aparecendo automaticamente um novo filho como primeiro cargo quando um departamento é criado, apenas a mensagem de que é necessário
*/
</script>